import React from "react";
import { Link } from "react-router-dom";

import MusicList from "./music-list";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMusic } from "@fortawesome/free-solid-svg-icons";

import setListStrategy from "../../assets/images/salty-setlist-strategy.png";

import "./music.scss";

library.add(faMusic);

function Music() {
  return (
    <div className="music-page">
      <div className="page-content gutter">
        <h1>Music we play</h1>
        <div className="row title-row">
          <FontAwesomeIcon className="page-icon" icon={faMusic} />
          <div className="page-copy">
            <p>
              We play an eclectic mix of 90's rock and roll, alternative rock
              and R&amp;B influenced music that's sure to electrify your event
              or venue. This is the music we love to play and it shows.
            </p>
          </div>
        </div>
        <div className="row">
          <MusicList />
        </div>
        <div className="row set-list-sets">
          <div className="set-flexibility">
            <h2>Planning Your Event</h2>
            <p>
              We schedule our music to celebrate your event the right way. Our shows can be booked from 1-4 hours, with 1-3 sets of music and an encore.
              We're happy to emcee or make announcements that support your event or venue.
            </p>
            <p>
              Have questions about booking us? Send us a message by visiting our {" "}
              <Link reloadDocument 
                to='/contact' 
                target='_self'>
                  Contact
              </Link>
              {" "} page.
            </p>
          </div>
        </div>
        <div className="row set-list-strategy">
          <img src={setListStrategy} className="set-list-strategy-image" alt="How we choose songs"></img>
          <div className="set-list-strategy-text">
            <h2>How we choose songs</h2>
            <ul>
              <li>
                <h3>Songs Our Audience Loves</h3>
                <p>We play the songs you don't hear enough from live cover bands. The hottest rock, grunge, alternative and groove hits from yesterday and today.</p>
              </li>
              <li>
                <h3>Songs We Love</h3>
                <p>We play the songs we love and it shows</p>
              </li>
              <li>
                <h3>No Mustang Sally!</h3>
                <p>We know you love these songs! Mustang Sally, Brown Eyed Girl ... great songs, but a lot of bands already play them so we're happy to provide an alternative</p>
              </li>
              <li>
                <h3>Experiments</h3>
                <p>We're music fans! These song choices often come from one of us saying "I have a crazy idea..."</p>
              </li>
            </ul>
          </div>
        </div>
        <div className="copyright">All trademarks are &copy; Copyright of their respective owners.</div>
      </div>
    </div>
  );
}

export default Music;
